import { render } from "./AnswerSheet.vue?vue&type=template&id=c4002620&scoped=true&ts=true"
import script from "./AnswerSheet.vue?vue&type=script&lang=ts"
export * from "./AnswerSheet.vue?vue&type=script&lang=ts"

import "./AnswerSheet.vue?vue&type=style&index=0&id=c4002620&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4002620"]])

export default __exports__